let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hE9P6")).then(() => parcelRequire('gwOgn'));